import React, { useState } from "react"

import dayjs from "dayjs";

import { useRepositoryItems, repositoryTypes, targetTypes as repositoryTargetTypes } from "../../../../hooks/api/useRepositoryItems";

import { useProduct, productLoadStatusTypes, productInjectionFields } from "./useProduct";
import { useContainerSummary } from "./useContainerSummary";

import {
    useInjectionFields,
    getUpdateFieldValuesPayload,
    scopeTypes as injectionFieldScopeTypes,
} from "../../../../hooks/api/useInjectionFields"

import {
    createProductInjectionFieldsPayload,
    // createContainerInjectionFieldsPayload
} from "../../utils/injectionFields"

import {
    useSchedulers,
    schedulerConfigs,
    schedulerTypes,
    targetTypes as schedulerTargetTypes,
    schedulerModules,
    schedulerRefs,
    schedulerTargets
} from "../../../../hooks/api/useSchedulers"

import {
    itemInjectionFields,
} from "./useProductItem";

import { getInjectionDataType } from "../../utils/injectionSelection";

export function useContainerItem({
    jwtToken: _jwtToken,
    routeType: _routeType
}) {

    const [routeType, setRouteType] = useState(_routeType)

    const { list, get, filterOperatorTypes } = useRepositoryItems({
        repositoryType: repositoryTypes.container,
        targetType: repositoryTargetTypes.container
    });

    const { getProduct, splitProduct, listProducts } = useProduct({ routeType })
    const { updateContainerSummary } = useContainerSummary({ routeType })

    const { updateFieldValues } = useInjectionFields({
        scopeType: injectionFieldScopeTypes.item.id
    });

    const {
        create: createSchedulerRequest
    } = useSchedulers({ schedulerType: schedulerTypes.schedulerRequest, targetType: schedulerTargetTypes.schedulerRequest })


    // list container items
    const listContainerItems = async ({
        props,
        dataTypes = [`${getInjectionDataType('container')}`]
    }) => {

        props.dataTypes = dataTypes

        let filterValues = [
        ]

        if (props?.filterValue) {
            props.filterValue = [...props.filterValue, ...filterValues]
        } else {
            props.filterValue = filterValues
        }

        const result = await list(props)

        let data = result?.data?.items ? result.data.items : []

        return {
            data,
            // count: result?.data?.nofilter_total
            count: result?.data?.total
        }

    }

    // done
    // add item into container (single)
    const addContainerItem = async ({
        productId: _productId,
        // totalInputQty: _totalInputQty,
        // totalMaxQty: _totalMaxQty,
        inputs = [{
            itemId: "",
            loadQty: {
                inputQty: 0,
                maxQty: 0,
            }
        }],
        loadContainerDateTime: _loadContainerDateTime = dayjs().format("YYYY-MM-DD HH:mm:ss"),
        needToSplit: _needToSplit,
        containerId: _containerId,
        containerSourceRemId: _containerSourceRemId,
        customSchedulerIntegrationId: _customSchedulerIntegrationId = ''
    }) => {

        let _totalInputQty = inputs.reduce((total, i5) => {
            let inputQty = i5?.loadQty?.inputQty
            total += parseInt(inputQty, 10)
            return total
        }, 0)

        let _totalMaxQty = inputs.reduce((total, i5) => {
            let inputQty = i5?.loadQty?.maxQty
            total += parseInt(inputQty, 10)
            return total
        }, 0)

        // check the total input must more than 0
        if (parseInt(_totalInputQty, 10) <= 0) {
            // promptMessage(false, ('youHaveToSelectTheQtyAtLeastMoreThan1Qty'))
            throw Error("youHaveToSelectTheQtyAtLeastMoreThan1Qty")
        }

        // only check if the enable split option is false - to check the total input qty must same with max qty
        if (_needToSplit === false) {
            if (parseInt(_totalInputQty, 10) !== parseInt(_totalMaxQty, 10)) {
                // promptMessage(false, t(`youHaveToSelectTheFullQtyIfThereIsNotSplitOption`))
                throw Error("youHaveToSelectTheFullQtyIfThereIsNotSplitOption")
            }
        }

        let dataTypesArray = [`${getInjectionDataType('product')}`, `${getInjectionDataType('item')}`]

        const fromProductData = await getProduct({
            id: _productId,
            dataTypesArray
        })

        let {
            product: fromProductDataProduct,
            items: fromProductItemsData
        } = fromProductData

        // console.log('fromProductDataProduct', fromProductDataProduct)

        let fromProductDataSourceRemId = fromProductDataProduct[productInjectionFields.sourceProductRemId.retrieveKey]
        let fromProductDataSplitFromRemId = fromProductDataProduct[productInjectionFields.splitFromRemId.retrieveKey]
        let fromProductDataIsSplit = fromProductDataProduct[productInjectionFields.isSplit.retrieveKey]

        if (!fromProductDataSourceRemId) {
            // promptMessage(false, t('selectedProductHasNotSyncToHQYet'))
            throw Error("selectedProductHasNotSyncToHQYet")
        }

        if (fromProductDataProduct[productInjectionFields.loadStatus.retrieveKey] === productLoadStatusTypes.loaded.value) {
            throw Error("selectedProductHasBeenLoadedToContainer")
        }

        const hasQtyChanged = inputs.some(input => {
            const freshItem = fromProductItemsData.find(i5 => i5.id === input.itemId)
            const freshPackQty = parseFloat(freshItem ? freshItem[itemInjectionFields.packQty.retrieveKey] : 0)

            return freshPackQty < parseFloat(input.loadQty.maxQty)
        })

        if (hasQtyChanged) {
            throw Error("selectedProductQtyHasChanged")
        }

        let _splitFromRemId = ''

        // if have split before use the splitRemId if not use own remid
        if (fromProductDataIsSplit === "1") {
            _splitFromRemId = fromProductDataSplitFromRemId
        } else {
            _splitFromRemId = fromProductDataSourceRemId // use own remid
        }

        // console.log('_needToSplit', _needToSplit, fromProductDataProduct)

        // check whether need to split the product
        if (_needToSplit === true) {


            let splitFromProduct = {
                itemName: fromProductDataProduct?.item_name,
                model: fromProductDataProduct?.model,
                productCode: fromProductDataProduct?.product_code,
                description: fromProductDataProduct?.description,
                categoryId: fromProductDataProduct?.category_id,
                brandId: fromProductDataProduct?.brand_id,
                summary: fromProductDataProduct?.summary,
                marking: fromProductDataProduct[productInjectionFields.customerMarking.retrieveKey],
                userBranchId: fromProductDataProduct[productInjectionFields.customerBranchId.retrieveKey],
                userId: fromProductDataProduct[productInjectionFields.customerUserId.retrieveKey],
                checkinDateTime: fromProductDataProduct[productInjectionFields.checkinDateTime.retrieveKey],

                appPrintPackQty: fromProductDataProduct[productInjectionFields.appPrintPackQty.retrieveKey],
                isAppEntry: fromProductDataProduct[productInjectionFields.isAppEntry.retrieveKey],

                supplierName: fromProductDataProduct[productInjectionFields.supplierName.retrieveKey],
                supplierContact: fromProductDataProduct[productInjectionFields.supplierContact.retrieveKey],
                courierTrackingNo: fromProductDataProduct[productInjectionFields.courierTrackingNo.retrieveKey],
                prepaidDepositAmount: fromProductDataProduct[productInjectionFields.prepayDepositFee.retrieveKey],
                prepaidTransportAmount: fromProductDataProduct[productInjectionFields.prepayTransportFee.retrieveKey],
                signUserId: fromProductDataProduct[productInjectionFields.signedByUserId.retrieveKey],
                signUserDisplay: fromProductDataProduct[productInjectionFields.signedByUserDisplay.retrieveKey],
                remark: fromProductDataProduct[productInjectionFields.remark.retrieveKey],
                paymentType: fromProductDataProduct[productInjectionFields.paymentMethod.retrieveKey],
                purchaseNumber: fromProductDataProduct[productInjectionFields.companyPurchaseNumber.retrieveKey],
                supplierPurchaseNumber: fromProductDataProduct[productInjectionFields.supplierPurchaseNumber.retrieveKey],
                barcode: fromProductDataProduct[productInjectionFields.barcode.retrieveKey],
                locationId: fromProductDataProduct[productInjectionFields.registerLocationId.retrieveKey],
                locationDisplay: fromProductDataProduct[productInjectionFields.registerLocationDisplay.retrieveKey],
                nfcPersonName: fromProductDataProduct[productInjectionFields.nfcPersonName.retrieveKey],
                nfcIdentityNo: fromProductDataProduct[productInjectionFields.nfcIdentityNo.retrieveKey],
                nfcFileId: fromProductDataProduct[productInjectionFields.nfcFileId.retrieveKey],
                nfcDetails: fromProductDataProduct[productInjectionFields.nfcDetails.retrieveKey]
            }

            let splitFromProductItems = fromProductItemsData.map(i5 => {

                // check the inputs
                let _selected = inputs.filter(i2 => i2.itemId === i5.id)

                let _inputQty = _selected.length > 0 ? _selected[0].loadQty.inputQty : 0
                let _maxQty = _selected.length > 0 ? _selected[0].loadQty.maxQty : 0

                // console.log('inputs', inputs, _selected)

                return {
                    itemId: i5?.id,
                    uomId: i5?.uom_id,
                    uomName: i5?.uom_name,
                    code: i5?.code,
                    cost: i5?.cost,
                    uomPrice: i5?.uom_price,
                    floorPrice: i5?.floor_price,
                    remark: i5?.remark,
                    grossWeight: i5?.gross_weight,
                    netWeight: i5?.net_weight,
                    volumeWeight: i5?.volume_weight,
                    itemDescription: i5?.item_description,
                    dimensionWidth: i5?.dimension_width,
                    dimensionHeight: i5?.dimension_height,
                    dimensionLength: i5?.dimension_length,
                    cbm: i5?.cbm,
                    scanningCodeSuffix: i5?.scanning_code_suffix,
                    // status: 1,
                    // is_package: 0,
                    customUomName: i5[itemInjectionFields.uomName.retrieveKey],

                    handleQty: i5[itemInjectionFields.handleQty.retrieveKey],
                    handleQtyPerPackage: i5[itemInjectionFields.qtyPerPackage.retrieveKey],
                    loadQty: {
                        inputQty: _inputQty,
                        maxQty: _maxQty
                    },
                }
            })

            let allSplitParams = {
                fromProduct: splitFromProduct,
                fromProductItems: splitFromProductItems,
                splitFromRemId: _splitFromRemId,
                // currentInput: currentValues,
                customSchedulerIntegrationId: _customSchedulerIntegrationId
            }

            // console.log('allSplitParams', allSplitParams)

            await splitProduct(allSplitParams)

        }

        // append inj fields - for existing product load status
        let injectionFieldsLoaded = createProductInjectionFieldsPayload({
            productId: _productId,
            barcode: ``,
            locationId: "",
            locationDisplay: "",
            data: {},
            mainData: {
                isSplit: (_needToSplit === true || fromProductDataIsSplit === "1") ? 1 : 0,
                // splitFromRemId: fromProductDataSourceRemId
                splitFromRemId: (_needToSplit === true || fromProductDataIsSplit === "1") ? _splitFromRemId : 0
            },
            targetInjectionFieldIds: [
                `loadStatus`,
                `loadContainerId`,
                `loadContainerDateTime`,
                `isSplit`,
                `splitFromRemId`
            ],
            loadStatus: productLoadStatusTypes.loaded.value,
            loadContainerId: _containerId,
            loadContainerDateTime: _loadContainerDateTime
        })

        // injection fields
        await updateFieldValues({ data: getUpdateFieldValuesPayload({ items: injectionFieldsLoaded }), overrideScopeType: injectionFieldScopeTypes.item.id })

        // calculate the current container summary
        let containerSummary = await updateContainerSummary({ containerId: _containerId, listProducts })

        // console.log('schedulerConfigs?.schedulerIntegrationIds', schedulerConfigs?.schedulerIntegrationIds)

        if (
            (schedulerConfigs?.schedulerIntegrationIds &&
                schedulerConfigs?.schedulerIntegrationIds.length > 0) ||
            _customSchedulerIntegrationId !== ''
        ) {

            let integrationId = schedulerConfigs?.schedulerIntegrationIds[0]

            if (_customSchedulerIntegrationId) {
                integrationId = _customSchedulerIntegrationId
            }

            let dataTypesArray = [`${getInjectionDataType('product')}`, `${getInjectionDataType('item')}`]

            // let currentProduct = await fetchProduct({ productId })
            const currentProduct = await getProduct({
                id: _productId,
                dataTypesArray
            })

            // let currentProductSourceProductRemId = currentProduct[productInjectionFields]

            // console.log('currentProduct', currentProduct)

            let currentProductProduct = currentProduct?.product ? currentProduct.product : {}

            let dataSchedulerRequest = {
                scheduler_request: {
                    source_id: _productId,
                    target: schedulerTargets.request.item,
                    module: schedulerModules.request.item.product,
                    request_ref: schedulerRefs.request.item.product,
                    integration_id: integrationId,
                    destination_id: currentProductProduct[productInjectionFields.sourceProductRemId.retrieveKey],
                    action: 'update',
                    source_data:
                        JSON.stringify({
                            ...currentProduct,
                            registerLocationId: currentProductProduct[productInjectionFields.registerLocationId.retrieveKey],
                            productRemark: currentProductProduct[productInjectionFields.remark.retrieveKey],
                            sourceProductRemId: currentProductProduct[productInjectionFields.sourceProductRemId.retrieveKey],
                            sourceContainerRemId: _containerSourceRemId,
                            sourceSplitFromRemId: _splitFromRemId,
                            updateType: "loadContainer",
                            haveSplit: Boolean(_needToSplit)
                        })
                }
            }

            console.log('create load update product SR : ', JSON.stringify(dataSchedulerRequest))

            // create scheduler request
            await createSchedulerRequest({ data: dataSchedulerRequest, schedulerType: schedulerTypes.schedulerRequest, targetType: schedulerTargetTypes.schedulerRequest })

        }

    }

    // done
    // add item into container - (Bulk) (No Split Option)
    const addContainerItemBulk = async ({
        // productIds: _productIds,
        products: _products = [],
        // totalInputQty: _totalInputQty,
        // totalMaxQty: _totalMaxQty,
        // inputs = [{
        //     itemId: "",
        //     loadQty: {
        //         inputQty: 0,
        //         maxQty: 0,
        //     }
        // }],
        loadContainerDateTime: _loadContainerDateTime = dayjs().format("YYYY-MM-DD HH:mm:ss"),
        // needToSplit: _needToSplit,
        containerId: _containerId,
        containerSourceRemId: _containerSourceRemId
    }) => {

        let _needToSplit = false

        // validation
        let validationStatus = true
        let validationMessage = []

        // console.log('_products,', _products)

        _products.forEach(i => {

            let fromProductDataSourceRemId = i[productInjectionFields.sourceProductRemId.retrieveKey]
            // let fromProductDataSplitFromRemId = i[productInjectionFields.splitFromRemId.retrieveKey]
            // let fromProductDataIsSplit = i[productInjectionFields.isSplit.retrieveKey]

            if (!fromProductDataSourceRemId) {
                // promptMessage(false, t('selectedProductHasNotSyncToHQYet'))
                validationStatus = false
                validationMessage.push("selectedProductHasNotSyncToHQYet")
            }

        })

        // console.log('validationMessage', validationStatus, validationMessage)

        // validation
        if (validationStatus === false) {
            throw Error(validationMessage.join(", "))
        }

        const freshProductsData = await Promise.all(_products.map(product => getProduct({
            id: product.id,
            dataTypesArray: [`${getInjectionDataType('product')}`]
        })))

        const hasLoadedProduct = freshProductsData.some(freshProductData =>
            freshProductData?.product?.[productInjectionFields.loadStatus.retrieveKey] === productLoadStatusTypes.loaded.value
        )

        if (hasLoadedProduct) {
            throw Error("selectedProductHasBeenLoadedToContainer")
        }

        let allInjectionFields = []
        let _productIds = []

        _products.forEach((i, index) => {

            let _productId = i.id
            let fromProductDataSourceRemId = i[productInjectionFields.sourceProductRemId.retrieveKey]
            let fromProductDataSplitFromRemId = i[productInjectionFields.splitFromRemId.retrieveKey]
            let fromProductDataIsSplit = i[productInjectionFields.isSplit.retrieveKey]

            let _splitFromRemId = ''

            _productIds.push(_productId)

            // if have split before use the splitRemId if not use own remid
            if (fromProductDataIsSplit === "1") {
                _splitFromRemId = fromProductDataSplitFromRemId
            } else {
                _splitFromRemId = fromProductDataSourceRemId // use own remid
            }

            // get the 1 second later for each loop for loadContainerDateTime
            const a = dayjs(_loadContainerDateTime)
            const b = a.add((index), 'second')
            let newLoadContainerDateTime = b.format("YYYY-MM-DD HH:mm:ss")


            // append inj fields - for existing product load status
            let injectionFieldsLoaded = createProductInjectionFieldsPayload({
                productId: _productId,
                barcode: ``,
                locationId: "",
                locationDisplay: "",
                data: {},
                mainData: {
                    isSplit: (fromProductDataIsSplit === "1") ? 1 : 0,
                    // splitFromRemId: fromProductDataSourceRemId
                    splitFromRemId: (fromProductDataIsSplit === "1") ? _splitFromRemId : 0
                },
                targetInjectionFieldIds: [
                    `loadStatus`,
                    `loadContainerId`,
                    `loadContainerDateTime`,
                    `isSplit`,
                    `splitFromRemId`
                ],
                loadStatus: productLoadStatusTypes.loaded.value,
                loadContainerId: _containerId,
                // loadContainerDateTime: _loadContainerDateTime
                loadContainerDateTime: newLoadContainerDateTime
            })

            allInjectionFields = [...allInjectionFields, ...injectionFieldsLoaded]

        })

        // console.table('allInjectionFields', allInjectionFields)

        // injection fields
        await updateFieldValues({ data: getUpdateFieldValuesPayload({ items: allInjectionFields }), overrideScopeType: injectionFieldScopeTypes.item.id })

        const props = {
            limit: -1,
            skip: 0,
            filterValue: [],
            sortInfo: {
                id: 'id',
                dir: 0,
            },
        };

        // calculate the current container summary
        let containerSummary = await updateContainerSummary({ containerId: _containerId, listProducts })
        // let {
        //     totalCbm,
        //     totalPackQty,
        //     totalWeight,
        //     totalValue
        // } = containerSummary

        // console.log('containerSummary', containerSummary)

        // // append inj fields - for container info
        // let injectionFieldsContainer = createContainerInjectionFieldsPayload({
        //     containerId: _containerId,
        //     data: {
        //         totalCbm,
        //         totalValue,
        //         totalPackQty,
        //         totalWeight
        //     },
        //     targetInjectionFieldIds: [
        //         `totalCbm`,
        //         `totalValue`,
        //         `totalPackQty`,
        //         `totalWeight`,
        //     ],
        // })

        // // injection fields
        // await updateFieldValues({ data: getUpdateFieldValuesPayload({ items: injectionFieldsContainer }), overrideScopeType: injectionFieldScopeTypes.repository.id })


        let { data: syncProducts } = await listProducts({ props, productIds: _productIds })

        // console.log('syncProducts', syncProducts)

        await Promise.all(syncProducts.map(async (i) => {

            let _productId = i.id

            let dataSchedulerRequest = {
                scheduler_request: {
                    source_id: _productId,
                    target: schedulerTargets.request.item,
                    module: schedulerModules.request.item.product,
                    request_ref: schedulerRefs.request.item.product,
                    integration_id: schedulerConfigs?.schedulerIntegrationIds[0],
                    destination_id: i[productInjectionFields.sourceProductRemId.retrieveKey],
                    action: 'update',
                    source_data:
                        JSON.stringify({
                            product: i,
                            registerLocationId: i[productInjectionFields.registerLocationId.retrieveKey],
                            productRemark: i[productInjectionFields.remark.retrieveKey],
                            sourceProductRemId: i[productInjectionFields.sourceProductRemId.retrieveKey],
                            sourceContainerRemId: _containerSourceRemId,
                            // sourceSplitFromRemId: _splitFromRemId,
                            sourceSplitFromRemId: i[productInjectionFields.splitFromRemId.retrieveKey],
                            updateType: "loadContainer",
                            haveSplit: Boolean(_needToSplit)
                        })
                }
            }

            console.log('create load update product SR : ', JSON.stringify(dataSchedulerRequest))

            // create scheduler request
            await createSchedulerRequest({
                data: dataSchedulerRequest,
                schedulerType: schedulerTypes.schedulerRequest,
                targetType: schedulerTargetTypes.schedulerRequest
            })

        }));

    }

    // done
    const deleteContainerItems = async ({
        productIds: _productIds = [],
        containerId: _containerId = '',
        sourceContainerRemId: _sourceContainerRemId
    }) => {

        let injectionFieldsProduct = []

        _productIds.forEach(productId => {

            // change inj fields - for existing product load status & container id
            let b = createProductInjectionFieldsPayload({
                productId,
                barcode: ``,
                data: {},
                mainData: {},
                targetInjectionFieldIds: [
                    `loadStatus`,
                    `loadContainerId`,
                    // `loadContainerDateTime`
                ],
                loadStatus: productLoadStatusTypes.pending.value,
                loadContainerId: 0,
                // loadContainerDateTime: "" // empty the load datetime
            })

            injectionFieldsProduct = [...injectionFieldsProduct, ...b]

        })

        if (injectionFieldsProduct.length > 0) {

            // injection fields
            const responseProductInjectionFields = await updateFieldValues({ data: getUpdateFieldValuesPayload({ items: injectionFieldsProduct }), overrideScopeType: injectionFieldScopeTypes.item.id })

            // console.log('responseProductInjectionFields', responseProductInjectionFields)
            console.log('responseProductInjectionFields', responseProductInjectionFields)
        }

        // console.log('schedulerConfigs?.schedulerIntegrationIds', schedulerConfigs?.schedulerIntegrationIds)

        // calculate the current container summary
        let containerSummary = await updateContainerSummary({ containerId: _containerId, listProducts })
        // let {
        //     totalCbm,
        //     totalPackQty,
        //     totalWeight,
        //     totalValue
        // } = containerSummary

        // console.log('containerSummary', containerSummary)

        // // append inj fields - for container info
        // let injectionFieldsContainer = createContainerInjectionFieldsPayload({
        //     containerId: _containerId,
        //     data: {
        //         totalCbm,
        //         totalValue,
        //         totalPackQty,
        //         totalWeight
        //     },
        //     targetInjectionFieldIds: [
        //         `totalCbm`,
        //         `totalValue`,
        //         `totalPackQty`,
        //         `totalWeight`,
        //     ],
        // })

        // // injection fields
        // await updateFieldValues({ data: getUpdateFieldValuesPayload({ items: injectionFieldsContainer }), overrideScopeType: injectionFieldScopeTypes.repository.id })


        if (
            schedulerConfigs?.schedulerIntegrationIds &&
            schedulerConfigs?.schedulerIntegrationIds.length > 0
        ) {

            let dataTypes = [`${getInjectionDataType('product')}`, `${getInjectionDataType('item')}`]

            const props = {
                limit: -1,
                skip: 0,
                filterValue: [{
                    name: 'id',
                    operator: filterOperatorTypes.anyOf,
                    value: JSON.stringify(_productIds)
                }],
                sortInfo: {
                    id: "id",
                    dir: 0
                }
            }

            // props.itemType = itemTypes.product

            // const result = await listItems(props)
            // const { data } = await listProducts({ props, dataTypes })

            // get all related products 
            // let allRelatedProducts = await listProducts({ productIds: selectedProductIds })
            let { data: allRelatedProducts } = await listProducts({ props, dataTypes })

            let promises = [];

            _productIds.forEach(async (i) => {

                let productId = i

                let _currentProduct = allRelatedProducts.filter(i2 => i2.id === productId)

                let currentProduct = _currentProduct.length > 0 ? _currentProduct[0] : {}

                // let currentProductSourceProductRemId = currentProduct[productInjectionFields]

                // console.log('currentProduct', currentProduct)

                let dataSchedulerRequest = {
                    scheduler_request: {
                        source_id: productId,
                        target: schedulerTargets.request.item,
                        module: schedulerModules.request.item.product,
                        request_ref: schedulerRefs.request.item.product,
                        integration_id: schedulerConfigs?.schedulerIntegrationIds[0],
                        destination_id: currentProduct[productInjectionFields.sourceProductRemId.retrieveKey],
                        action: 'update',
                        source_data:
                            JSON.stringify({
                                ...currentProduct,
                                registerLocationId: currentProduct[productInjectionFields.registerLocationId.retrieveKey],
                                sourceProductRemId: currentProduct[productInjectionFields.sourceProductRemId.retrieveKey],
                                sourceContainerRemId: _sourceContainerRemId,
                                updateType: "unloadContainer"
                            })
                    }
                }

                // console.log('dataSchedulerRequest', JSON.stringify(dataSchedulerRequest))

                // create scheduler request
                promises.push(
                    await createSchedulerRequest({ data: dataSchedulerRequest, schedulerType: schedulerTypes.schedulerRequest, targetType: schedulerTargetTypes.schedulerRequest })
                )

            })

            let a = await Promise.all(promises)
            // console.log('a', promises.length, a)

        }

    }

    return {
        filterOperatorTypes,
        listContainerItems,
        addContainerItem,
        addContainerItemBulk,
        deleteContainerItems
    }
}